import React, { PropTypes } from 'react';
import '../../styles/ObservationInfo';
import _ from 'lodash';
import { Link } from 'react-router';
import LoadingModal from './LoadingModal';
import { pluralOf } from '../../../a2i/js/lib/stringFormatter';

let ObservationInfo = React.createClass({
	propTypes: {
		currentCycleNumber: PropTypes.number.isRequired,
		hasAnsweredSummaryQuestions: PropTypes.bool.isRequired,
		isTimeForStudentObservation: PropTypes.bool.isRequired,
		isTimeForTeacherObservation: PropTypes.bool.isRequired,
		isTimeForSummaryQuestions: PropTypes.bool.isRequired,
		mostRecentObservationId: PropTypes.number,
		toggleAnswerSummaryQuestions: PropTypes.func.isRequired,
		toggleStudentObservation: PropTypes.func.isRequired,
		toggleTeacherObservation: PropTypes.func.isRequired,
		observation: PropTypes.object.isRequired,
		uploadObservation: PropTypes.func.isRequired
	},

	getInitialState: function() {
		return {
			isShowingSuccess: false,
			isUploadingObservation: false,
			uploadFailureCount: 0
		};
	},

	componentWillMount: function() {
		if (this.props.hasAnsweredSummaryQuestions) {
			this.uploadObservation();
		}
	},

	uploadObservation: function() {
		this.setState({ isUploadingObservation: true });

		this.props.uploadObservation(this.props.observation).then(() => {
			this.setState({ isShowingSuccess: true, isUploadingObservation: false });

			setTimeout(() => {
				this.setState({ isShowingSuccess: false });
			}, 1000);
		}, () => {
			console.warn('Observation upload failed.  Retrying...');
			this.setState({ uploadFailureCount: this.state.uploadFailureCount + 1 });
			setTimeout(() => {
				this.uploadObservation();
			}, 2000);
		});
	},

	getObservationStepClassName: function(type, cycleNumber) {
		let {
			currentCycleNumber,
			hasAnsweredSummaryQuestions,
			isTimeForStudentObservation,
			isTimeForTeacherObservation,
			isTimeForSummaryQuestions
		} = this.props;

		let className = 'observation-step';

		if (type === 'questions' && isTimeForSummaryQuestions && !hasAnsweredSummaryQuestions) {
			className += ' active';
		} else if (type === 'questions' && hasAnsweredSummaryQuestions) {
			className += ' complete';
		} else if (cycleNumber === currentCycleNumber) {
			if (
				(type === 'student' && isTimeForStudentObservation) ||
				(type === 'teacher' && isTimeForTeacherObservation)
			) {
				className += ' active';
			} else if (
				(type === 'student' && !isTimeForStudentObservation) ||
				(type === 'teacher' && isTimeForSummaryQuestions)
			) {
				className += ' complete';
			}
		} else if (currentCycleNumber > cycleNumber) {
			className += ' complete';
		}

		return className;
	},

	handleNextClick: function() {
		if (this.props.isTimeForStudentObservation) {
			this.props.toggleStudentObservation();
		} else if (this.props.isTimeForTeacherObservation) {
			this.props.toggleTeacherObservation();
		} else if (this.props.isTimeForSummaryQuestions) {
			this.props.toggleAnswerSummaryQuestions();
		}
	},

	render: function() {
		return(
			<div className="observation-info container">
				<h2>
					{ this.props.hasAnsweredSummaryQuestions ? 'Observation Complete' : 'Observation In Progress' }
				</h2>
				<div className="observation-details">
					<div className="observation-classroom-info">
						Observing students in <span className="observation-info-classroom-description">{ this.props.observation.classroom.description }</span> taught by <span className="observation-info-teacher-name">{ this.props.observation.teacher.name }</span>
					</div>
					<div className="observation-students-info">
						{ pluralOf(this.props.observation.students.length, 'Student') } being observed:
						<ol>
							{
								this.props.observation.students.asMutable({ deep: true }).map((student) => {
									return (
										<li key={ 'student-' + student.id }>
											{ student.last_name + ', ' + student.first_name }
										</li>
									);
								})
							}
						</ol>
					</div>
				</div>
				{
					_.times(this.props.observation.number_of_cycles, (index) => {
						return (
							<div
								className={ 'observation-cycle' + (this.props.currentCycleNumber === index + 1 ? ' active' : '') }
								key={ index }
							>
								<h3>Cycle { index + 1 }</h3>
								<ul>
									<li className={ this.getObservationStepClassName('student', index + 1) }>
										Student observation ({ this.props.observation.student_minutes } minutes)
									</li>
									<li className={ this.getObservationStepClassName('teacher', index + 1) }>
										Teacher observation ({ this.props.observation.teacher_minutes } minutes)
									</li>
									{
										index + 1 === this.props.observation.number_of_cycles ? (
											<li className={ this.getObservationStepClassName('questions', index + 1) }>
												Summary Questions
											</li>
										) : ''
									}
								</ul>
							</div>
						);
					})
				}
				{
					this.props.hasAnsweredSummaryQuestions ? (
						<div className="observation-complete">
							This observation is complete.
						</div>
					) : ''
				}
				<div className="observation-info-controls">
					<a className="btn btn-lg btn-default" href="/">Back to menu</a>
					{
						this.props.observation.gold_standard_observation_id && this.props.hasAnsweredSummaryQuestions ? (
							<span>
								{' '}
								<a
									className="btn btn-lg btn-primary"
									href={ '/observations/' + this.props.mostRecentObservationId + '/scores/' }
								>
									View scores
								</a>
							</span>
						) : ''
					}
					{' '}
					{
						this.props.hasAnsweredSummaryQuestions ? '' : (
							<button
								className="btn btn-lg btn-primary"
								onClick={ this.handleNextClick }
								disabled={ this.state.isUploadingObservation }
							>
								{
									(this.props.isTimeForStudentObservation && (this.props.currentCycleNumber === 1)) ? (
										<span>Start{' '}<i className="glyphicon glyphicon-arrow-right" /></span>
									) : (
										<span>Next{' '}<i className="glyphicon glyphicon-arrow-right" /></span>
									)
								}
							</button>
						)
					}
					<LoadingModal
						message="Uploading observation"
						shouldShow={ this.state.isUploadingObservation }
						subtitle={ this.state.uploadFailureCount > 0 ? this.state.uploadFailureCount + ' attempts...' : null }
					/>
					<LoadingModal
						iconClass="fas fa-check observation-info-success-icon"
						message="Observation saved!"
						shouldShow={ this.state.isShowingSuccess }
					/>
				</div>
			</div>
		);
	}
});

module.exports = ObservationInfo;



// WEBPACK FOOTER //
// ./frontend/olos/js/components/ObservationInfo.jsx